import type { MapMouseEvent } from '@/lib/map-x/webmap-viewer-types'
import type MapFeature from '@/lib/map-feature'

import { getClickMode, CLICK_MODES } from '@/lib/map-click-handler/click-modes'
import { handleNonMarkupClick } from '@/lib/map-click-handler/feature-handlers/shared-handlers'
import type { DispatchProps } from '@/lib/map-click-handler/types'
import { classifyFeatures } from '@/lib/map-click-handler/classify-features'

function dispatchClick({
  mode,
  queryFeatures,
  classifiedFeatures,
  state,
  event,
  zoom,
}: DispatchProps) {
  // Get correct click mode, or fall back to a basic map query
  const clickMode = CLICK_MODES[mode] ?? {
    handler: () => handleNonMarkupClick(event, zoom),
  }

  return clickMode.handler({
    mode,
    queryFeatures,
    classifiedFeatures,
    state,
    event,
    zoom,
  })
}

/**
 * Routes a map click event through feature classification and dispatches to the appropriate click mode handler.
 */
export const clickHandler = (
  queryFeatures: MapFeature[],
  event: MapMouseEvent,
  zoom: number
) => {
  // Start by classifying all map features a user has clicked on
  const { classifiedFeatures, state } = classifyFeatures(queryFeatures)

  // Establish current click mode
  const mode = getClickMode()

  // Route handling to correct function for given feature clicked
  return dispatchClick({
    mode,
    queryFeatures,
    classifiedFeatures,
    state,
    event,
    zoom,
  })
}
